import React from 'react';
import {AutocompleteDictionary} from './autocomplete';
import {useSelector} from 'react-redux';
import {ethnicGroupsDict, gendersDict} from '../../store/reducers/dicts';
import AgyleDictionaryField from '../../components/ui/selector/agyleDictionaryField';

// Gender
function ControlGender(props) {
    const getDictionaryURL = (filter) => {
        if (props.fromAdmit) {
            return `/$dict/Genders?$filter=${encodeURIComponent(filter)}&$sort=description`;
        }
        return `/$dict/Genders?$filter=${encodeURIComponent(filter)}&$sort=code`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.__description}</div>;
    };

    return (
        <AutocompleteDictionary
            showAll
            getOptionSelected={(option, value) => option.__id === value.__id}
            getOptionLabel={(option) => option.__description}
            renderLocalOption={renderOptionLine}
            searchColumnName={'description'}
            dictionaryURL={getDictionaryURL}
            {...props}
        />
    );
}

// Gender
function ControlGenderECDS(props) {
    const dict = useSelector(gendersDict);

    function filterOptions(options, {inputValue}) {
        return options.filter((option) => {
            const fieldsToSearch = ['__description'];
            return fieldsToSearch.some((field) => option[field].toLowerCase().includes(inputValue.toLowerCase()));
        });
    }

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

// Ethnic
function ControlEthnic(props) {
    const dict = useSelector(ethnicGroupsDict);

    function filterOptions(options, {inputValue}) {
        return options.filter((option) => {
            const fieldsToSearch = ['__description'];
            return fieldsToSearch.some((field) => option[field].toLowerCase().includes(inputValue.toLowerCase()));
        });
    }

    return <AgyleDictionaryField
        filterOptions={filterOptions}
        options={dict}
        {...props}
    />;
}

export {ControlGender, ControlGenderECDS, ControlEthnic};
